module.exports = __webpack_public_path__ + "img/parceiro3.b07888c0.png";